import React from 'react';
import { withStaticContent } from '../../../ui/components/static-content';
import Link from '../../../shared/components/hyperlink';
import AdaptiveImage from '../../../shared/components/adaptive-image';
import {Typography} from '@hpstellar/core';

const AlsoVisit = () => {
    return (
        <div className="also-visit">
            <Typography variant="boldL" tag="h5">
                Also visit
            </Typography>
            <hr />
            <Link to="https://garage.ext.hp.com/us/en.html" newTab={true}>
                <AdaptiveImage
                    maxWidth={300}
                    src={
                        'https://www.hp.com/us-en/shop/app/assets/images/uploads/prod/taw_TheGarage_logo1545074417061.png'
                    }
                    alt="The HP Garage"
                    title="The HP Garage"
                    loading={'lazy'}
                />
            </Link>
        </div>
    );
};

export default withStaticContent(AlsoVisit);
